import { Footer } from "@nju/feature-portal-footer";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { RegistrationPage } from "@nju/feature-sales-registration";
import { Alert, BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function Registration() {
  const alertText = (
    <>
      Na podany adres e-mail zostaną wysłane: potwierdzenie założenia konta oraz
      mail z prośbą o ustawienie hasła do konta nju. Założenie konta umożliwi
      klientowi kontrolę nad procesem zakupu, zarządzanie usługą (informacje o
      statusie zamówienia, datę najbliższej cyklicznej płatności, zarządzania
      sposobem płatności oraz historię płatności, informacja o swoim urządzeniu,
      zarządzanie swoim kontem, dostęp do artykułów z pomocą, opcja rezygnacji z
      usługi), czy kontakt z konsultantem nju na czacie.
    </>
  );

  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <div>
        <Alert iconName="info-circle" text={alertText} />
        <BlockContent grid="narrow" spacing="xl">
          <ClientSideOnly>
            <RegistrationPage />
          </ClientSideOnly>
        </BlockContent>
      </div>
      <Footer />
    </LayoutWrapper>
  );
}
